import React from "react";
import { SxProps, TextField } from "@mui/material";

interface NumberFieldProps {
    value: string;
    onChange: (value: string) => void;
    label: string;
    min?: number;
    max?: number;
    sx?: SxProps;
    fixedDecimals?: number;
    helperText?: string;
    placeholder?: string;
    slotProps?: any;
}

export default function NumberField({value, onChange, label, min = 0, max = 1000000, sx, fixedDecimals = 2, helperText, placeholder = "0.00", slotProps}: NumberFieldProps) {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        if (newValue === "") {
            onChange(newValue);
            return;
        }
        const numericValue = parseFloat(newValue);
        if (isValidNumber(newValue) && numericValue >= min && numericValue <= max) {
            onChange(newValue);
        }
    };

    const isValidNumber = (value: string) => {
        const regex = new RegExp(`^\\d*\\.?\\d{0,${fixedDecimals}}$`);
        return regex.test(value);
    };

    return (
        <TextField error={helperText !== "" && helperText !== undefined} helperText={helperText} slotProps={slotProps} sx={sx} size="small" label={label} value={value} onChange={handleChange} placeholder={placeholder}/>
    );
}
